import React from 'react'
import Button from '@material-ui/core/Button'
import type {ButtonProps} from '@material-ui/core/Button'

import useStyles from './styles'

interface ButtonDefaultProps extends ButtonProps {
  to?: string
  component?: React.ElementType
}

const ButtonDefault: React.FC<ButtonDefaultProps> = ({
  children,
  variant = 'text',
  component = 'button',
  color = 'primary',
  size = 'small',
  ...props
}) => {
  const classes = useStyles()

  return (
    <Button
      {...props}
      variant={variant}
      component={component}
      classes={{root: classes.btn}}
      color={color}
      size={size}
    >
      {children}
    </Button>
  )
}

export default ButtonDefault
